import { StateMachine } from "../../../vendor_core/core/src/states/StateMachine";
import IdleState from "../../../vendor_core/src/states/IdleState";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";

export default class BURIdleState extends IdleState {
    protected soundFaded = false;

    constructor(stateMachine: StateMachine) {
        super(stateMachine);
    }

    public enter(): void {
        super.enter();
        SpinModel.freespinsRunning = false;
        // Clear the accumulated win from the previous round
        SpinModel.accumulatedWin = 0;
    }
}
